import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import InfoArea from 'components/transport/issue/InfoArea';
import { ReactComponent as Talk } from 'assets/transport/issue/talk.svg'

const TransportIssue = () => {
    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <Container className="flex flex-col gap-6 mb-6 pt-21 h-full min-h-dvh">
                <div className='flex items-center gap-6'>
                    <p className='font-semibold text-3xl'>운송이슈</p>
                    <p className='font-semibold text-2xl'>INC01 - Loss : 화물 분실 (전부 또는 일부)</p>
                </div>
                <div className='bg-white border-[#9D9EB7] border-1 rounded-lg overflow-hidden'>
                    <div className='bg-[#F8F8FA] px-10 py-6 font-semibold'>
                        <p className='font-semibold text-2xl'>이슈 상세 내용</p>
                    </div>
                    <div className='flex flex-col gap-6 px-10 py-5'>
                        <InfoArea
                            title='Code'
                            description='사건 코드'
                            value='INC01'
                        />
                        <InfoArea
                            title='Type'
                            description='사건 유형'
                            value='Damage'
                        />
                        <InfoArea
                            title='Date'
                            description='사건 시간'
                            value='2025-08-18 14:20'
                        />
                        <InfoArea
                            title='Location'
                            description='사건 장소'
                            value='부산항 CY'
                        />
                        <InfoArea
                            title='Description'
                            description='사건 요약'
                            value='컨테이너 적재 중 충격으로 인한 포장 파손 발생'
                        />
                        <InfoArea
                            title='Impact'
                            description='피해 목록'
                            value='총 200 BOX 중 15 BOX 파손 (예상 손실액 2,000 USD)'
                        />
                        <InfoArea
                            title='Responsible Party'
                            description='사건 책임자'
                            value='터미널 작업자, 박00 외 3명'
                        />
                        <InfoArea
                            title='Action Taken'
                            description='사후 처리'
                            value='보험사 통보, 파손품 검수 진행'
                        />
                        <InfoArea
                            title='Status'
                            description='진행 상태'
                            value='In Progress'
                        />
                    </div>
                </div>

                <div className='bg-white border-[#9D9EB7] border-1 rounded-lg overflow-hidden'>
                    <div className='bg-[#F8F8FA] px-10 py-6 font-semibold'>
                        <p className='font-semibold text-2xl'>Solomonship AI 대응방안</p>
                    </div>
                    <div className='flex flex-col gap-12.5 p-10 text-2xl'>
                        <div className='font-semibold'>
                            1. 즉시보고<br /><br />

                            운송사 / 포워더 / 보험사에 사고 발생 사실을 신속히 통보<br />
                            SolomonShip 같은 플랫폼에서는 Incident Log 자동 등록 + 알림발송<br /><br />

                            2. 증빙확보<br />

                            사진 / 영상 촬영 (파손 · 누락 · 사고 현장)<br />
                            사고 발생 보고서 (Driver Report, Captain’s Note, Air Waybill Irregularity Report)
                        </div>

                        <div className='flex justify-center items-center gap-3 bg-[#FFD900] rounded max-w-[300px] h-15 cursor-pointer'>
                            <Talk /> 법률 담당자 1:1 연결
                        </div>
                    </div>
                </div>
            </Container>
        </PageTemplate>
    )
}

export default TransportIssue